import { StyledButton } from 'src/pages/DUPPage/styles';
import styled from 'styled-components/macro';

export const FormContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;

  /* inputs */
  > div > div {
    border-radius: 8px;
  }

  /* checkbox */
  & path {
    fill: ${({ theme }) => theme.redesignColor.gray[500]};
  }
`;

export const Button = styled(StyledButton)`
  width: 100%;
  margin-top: 1.5rem;
`;

export const TermsRow = styled.div`
  display: flex;
  width: 100%;
  margin: -0.75rem 0;
  gap: 0.3rem;
  align-items: center;

  & path {
    fill: ${({ theme }) => theme.redesignColor.gray[700]};
  }
`;

export const Terms = styled.div`
  height: 24px;
  ${({ theme }) => theme.redesignFont.caption}
  & a {
    ${({ theme }) => theme.redesignFont.caption}
    font-family: ${({ theme }) => theme.redesignFont.bold.fontFamily};
    text-transform: lowercase;

    &:hover {
      color: ${({ theme }) => theme.redesignColor.snappt[700]};
  }
`;

export const PrevSubmitRowContainer = styled.div`
  margin-bottom: 1.5rem;
  border-top: 1px solid ${({ theme }) => theme.redesignColor.gray[200]};
  border-bottom: 1px solid ${({ theme }) => theme.redesignColor.gray[200]};
  padding: 1rem;
  gap: 0.5rem;
  display: flex;
  flex-direction: column;
`;
